module.exports = __webpack_public_path__ + "img/viacredi.a08f6320.svg";